import "../../assets/sass/components/signIn/_signIn.scss";

import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, Redirect, useHistory } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";

import AppContext from "../../contexts/AppContext";
import GLOBAL from "../../global";
import CONSTANT from "../../constants/Constant";
import routes from "../../constants/Routes";
import authService from "../../services/AuthService";
import storageService from "../../utils/StorageService";

import { Trans, useTranslation } from "react-i18next";
import { invalidFormElement } from "../../utils/DefaultInitialization";
import { getUserIdentification, isMobileDevice, prepareEnabledSubscribedFeatures } from "../../utils/Utils";
import DisplayUrlContent from "../shared/DisplayUrlContent";

// import mmhColorLogo from '../../assets/img/signin/mmhLogo.svg';
// import doctorIcon from '../../assets/img/signin/doctor-icon.svg';
// import topRoundIcon from '../../assets/img/signin/topRound.svg';
// import leftIcon from '../../assets/img/signin/leftIcon.svg';
// import bottomRoundIcon from '../../assets/img/signin/bottomRound.svg';
import useRedirect from "../../hooks/useRedirect";
// import PackageSmallDetails from "../package/PackageSmallDetails";
// import usePaymentAndD2CRedirection from "../../hooks/usePaymentAndD2CRedirection";
import useD2C from "../../hooks/useD2C";
import { useHandleDirectPayment } from "../../contexts/DirectPaymentContext";
// import {redirectTo} from "../shared/chatbotNew/ChatServices";
// import {useAuth} from "../../contexts/OAuthContext";
import useSignIn from "./useSignIn";
import AlertModal from "../shared/AlertModal";
import MobileAppSuggestionsModal from "../MobileAppSuggestions/MobileAppSuggestionsModal";
import { createWebRTCToken } from "../shared/MovementModal/Services/AssessementService";
import { toast } from "react-toastify";
import { useTenantFeatures, getTenantFeatures } from "../../features/tenantFeatures/useTenantFeature";
import useDeviceCompatibility from "../../hooks/useDeviceCompatibility";

function SignIn(props) {
    const {
        authenticated,
        authenticate,
        deAuthenticate,
        storeUserInfo,
        storeUserInfoToLocalStorage
    } = useContext(AppContext);
    const [redirectToDashboard, setRedirectToDashboard] = useState(false);
    const [redirectToReports, setRedirectToReports] = useState(false);
    const [redirectToMyAssessments, setRedirectToMyAssessments] = useState(false);
    const [redirectToSignUp, setRedirectToSignUp] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [examneticsSuccessData, setExamneticsSuccessData] = useState(null);
    const { i18n } = useTranslation();
    const subscription = useRef(true);
    const [inputType, setInputType] = useState('password');
    const [termOfServiceModal, setTermOfServiceModal] = useState(false);
    const [showMobileAppSuggestion, setShowMobileAppSuggestion] = useState(false);

    const [privacyPolicyModal, setPrivacyPolicyModal] = useState(false);
    const location = useLocation();
    const { redirectKeepingQueryParams } = useRedirect();
    const { IsD2CEnabled } = useD2C();
    const history = useHistory();
    const [inviattionGId, setInviattionGId] = useState('');

    const {
        isLoading: isDirectPaymentLoading,
        email: directPaymentUserEmail,
        packageId: directPaymentPacakgeId,
        sessionId: directPaymentSessionId,
        isRegisteredUser: directPaymentIsRegisteredUser,
        clearDirectPaymentState
    } = useHandleDirectPayment();
    const { handleSignInResponse } = useSignIn();

    const { isAthleteEnabled } = useTenantFeatures();
    const { isMobileAppSuggestionModalEnabled } = useDeviceCompatibility();

    // const {
    //     // tokens,
    //     // isAuthenticated,
    //     login,
    //     // logout,
    //     // refreshTokens,
    //     // fetchWithToken,
    //     // loading,
    //     // error
    // } = useAuth();

    useEffect(() => {
        const url = window.location.href;
        const params = new URLSearchParams(url.slice(url.indexOf('?')));
        const invGId = params.get('InvGId') || params.get('invgid');

        if (invGId && params.get('RA') === 'true') {
            setInviattionGId(invGId)
        }
    }, []);

    // Check if session_id exists and isAthleteEnabled to hide Terms & Privacy Policy
    const urlParams = new URLSearchParams(location.search);
    const sessionId = urlParams.get('session_id');
    const shouldHideTermsAndPrivacy = sessionId && isAthleteEnabled;

    useEffect(() => {
        if (!GLOBAL.URL_PARAMS.IS_INTAKE_SIGNED) {
            deAuthenticate();
        }

        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        // Check if redirecting from sign-up page to prevent redirect loop
        const search = location.search;
        const queryString = search.includes('?') ? search.split('?')[1] : '';
        const params = new URLSearchParams(queryString);
        const redirectFrom = params.get('redirect_from');

        // Only redirect to sign-up if NOT coming from sign-up page
        if (directPaymentUserEmail && (!directPaymentIsRegisteredUser || isAthleteEnabled) && redirectFrom !== 'sign_up') {
            history.push(`${routes.signUp}${queryString ? '?' + queryString : ''}`);
        }
    }, [directPaymentUserEmail]);

    const onCancelMobileAppSuggestion = () => {
        setShowMobileAppSuggestion(false);
    };

    const initialValuesForLogin = () => {
        let tempEmail = '';

        if (props?.emailToLoadInitially) {
            tempEmail = props.emailToLoadInitially;
        }
        if (directPaymentUserEmail) {
            tempEmail = directPaymentUserEmail;
        }

        // Check for billing_email from sign-up redirect
        const urlParams = new URLSearchParams(location.search);
        const billingEmail = urlParams.get('billing_email');
        if (billingEmail) {
            tempEmail = billingEmail;
        }

        return {
            Email: tempEmail,
            Password: "",
            AcceptTerms: false
        };
    };

    const validationSchema = () => {
        return Yup.object().shape({
            Email: Yup.string()
                .email('Please enter a valid email')
                .required(i18n.t("common.message.error.required-field")),
            Password: Yup.string()
                .required(i18n.t("common.message.error.required-field"))
        });
    };

    const onSubmitLogin = async (values, actions) => {
        actions.setSubmitting(true);
        setErrorMessage('');
        setExamneticsSuccessData(null);

        // Get session_id and billing_email from query params
        const urlParams = new URLSearchParams(location.search);
        const sessionId = urlParams.get('session_id');
        const billingEmail = urlParams.get('billing_email');

        // Add SessionId and BillingEmail to login payload if they exist
        const loginPayload = {
            ...values
        };
        if (sessionId) {
            loginPayload.SessionId = sessionId;
        }
        if (billingEmail) {
            loginPayload.BillingEmail = billingEmail;
        }

        const response = await authService.login(loginPayload);
        const { data, success, error, originalData } = response;

        if (!success) {
            if (originalData?.Successful && originalData?.Title === "Screening Completed Successfully!") {
                setExamneticsSuccessData(originalData);
                actions.setSubmitting(false);
                return;
            }

            !error && setErrorMessage('Server error');
            error && setErrorMessage(error);
            actions.setSubmitting(false);
            return;
        }

        // storageService.addItem(CONSTANT.JWT.TOKEN_KEY, data?.Token);
        // storageService.addItem(CONSTANT.REFRESH_TOKEN.KEY_NAME, data?.RefreshToken);
        const userInfo = await handleSignInResponse(data);

        // let userInfo = data || '{}';
        const isProvider = userInfo['RoleName'] === CONSTANT.ROLE.PROVIDER;
        const isProviderLogin = storageService.getItem('providerLogin') === 'true';

        if (!isProviderLogin && isProvider) {
            setErrorMessage(`You are not ${getUserIdentification().toLowerCase()}, please go to the provider view`);
            return;
        }

        if (isProviderLogin && !isProvider) {
            setErrorMessage(`You are not provider, please go to the ${getUserIdentification().toLowerCase()} view`);
            return;
        }

        if (inviattionGId) {
            let webRTCCreateTokenResponse = await createWebRTCToken(inviattionGId);
            if (webRTCCreateTokenResponse?.success) {
                const webRTCPortalUrl = webRTCCreateTokenResponse?.data?.WrtcUrl || '';
                const token = webRTCCreateTokenResponse?.data?.Token || '';
                const url = window.location.href;
                const params = new URLSearchParams(url.slice(url.indexOf('?')));
                const qs = [`roomId=${token}`];
                if (params.get('TestId')) qs.push(`TestId=${params.get('TestId')}`);
                if (params.get('RA')) qs.push(`RA=${params.get('RA')}`);
                if (params.get('BodyRegionIds')) qs.push(`BodyRegionIds=${params.get('BodyRegionIds')}`);

                window.location.href = `${webRTCPortalUrl}/?roomId=${token}`;
            } else {
                toast.error(webRTCCreateTokenResponse?.error);
            }

            return;
        }

        // const subscriptionFeatures = await getSubscriptionFeatures(userInfo, isProvider);
        // userInfo.Permissions = prepareEnabledSubscribedFeatures(subscriptionFeatures);

        if (isProvider) {
            window.location.href = `https://${GLOBAL.TENANT}.${CONSTANT.URLS.BASE_URL}/account/painemmalogin?patientId=${userInfo['ContactId']}&redirecturl=home`;
            return;
        }

        if (userInfo.Permissions.IsNoFaultEnabled && !userInfo['IsIntakeSigned']) {
            window.location.href = `https://${GLOBAL.TENANT}.${CONSTANT.URLS.BASE_URL}/intake/info?patientId=${userInfo['ContactId']}&redirect=self&type=inclinic&invid=${GLOBAL.URL_PARAMS.INVITATION_ID}`;
            return;
        }

        // GLOBAL.USER_INFO = userInfo;
        // authenticate(true);
        // storeUserInfo(GLOBAL.USER_INFO);

        actions.setSubmitting(false);

        // storeUserInfoToLocalStorage();

        if (isMobileAppSuggestionModalEnabled && isMobileDevice()) {
            setShowMobileAppSuggestion(true);
            return;
        }

        let currentUrl = window.location.href;

        if (IsD2CEnabled && currentUrl.includes('package')) {
            // Check if user signed in from PackageDetailsPageWrapper and isAthleteEnabled is true
            if (props?.isFromPackageDetailsPage && isAthleteEnabled) {
                return window.location = `${routes.myAssessments}/false`;
            }
            return;
        }
        // let isRedirectedToStrip = await handleRedirectToStripe();
        // if (isRedirectedToStrip) return;

        // if (window.location.href.includes('?') && !GLOBAL.URL_PARAMS.IS_REPORT_DOWNLOAD) {
        //     setRedirectToScreening(true);
        // } else

        // if(directPaymentUserEmail) {
        //     const patientFullName = userInfo?.FullName || '';
        //     const respose = await DirectToConsumerService.directPaymentInvitationRequest({
        //         PackageGId: directPaymentPacakgeId,
        //         SessionId: directPaymentSessionId,
        //         BillingName: patientFullName,
        //     });
        //     if(response.success) {
        //         clearDirectPaymentState();
        //         history.replace({ pathname: location.pathname });
        //     }
        // }

        if (GLOBAL.URL_PARAMS.IS_REPORT_DOWNLOAD) {
            setRedirectToReports(true);
        } else {
            if (isAthleteEnabled) {
                setRedirectToMyAssessments(true);
            } else {
                setRedirectToDashboard(true);
            }
        }
    };

    // const getSubscriptionFeatures = async (userInfo, isProvider) => {
    //     let role = '';
    //     if (isProvider) {
    //         role = CONSTANT.ROLE.REFERRING_PROVIDER
    //     } else {
    //         role = CONSTANT.ROLE.PATIENT
    //     }
    //     const payload = { Role: role }
    //     const response = await authService.getSubscriptionFeature(payload);
    //     const { data, success, error } = response;
    //
    //     if (!success) {
    //         console.error(error)
    //         return;
    //     }
    //
    //     const subscriptionFeatures = data || '{}';
    //     GLOBAL.SUBSCRIPTION_FEATURES = subscriptionFeatures.Features;
    //     return subscriptionFeatures.Features;
    // }

    const onClickSignUp = (e) => {
        e.preventDefault();
        // setRedirectToSignUp(true);
        redirectKeepingQueryParams(routes.signUp);
    };

    const handleOnClickAreYouNewUser = (e) => {
        e.preventDefault();

        if (isAthleteEnabled) {
            const { defaultPackageURL } = getTenantFeatures();
            window.location = defaultPackageURL || routes.signUp;
        } else {
            props?.onClickRedirectToSignUp();
        }
    }

    useEffect(() => {
        if (subscription.current) {
            if (authenticated && !GLOBAL.URL_PARAMS.AUTO_LOGIN) {
                if (isAthleteEnabled) {
                    setRedirectToMyAssessments(true);
                } else {
                    setRedirectToDashboard(true);
                }
            }
        }

        return () => {
            subscription.current = false;
        };
    }, [authenticated]);

    if (redirectToDashboard) {
        return <Redirect to={`${routes.dashboard}${location?.search}`} />;
    }

    if (redirectToMyAssessments) {
        return <Redirect to={`${routes.myAssessments}/false${location?.search}`} />;
    }

    if (redirectToSignUp) {
        return <Redirect to={`${routes.signUp}`} />;
    }

    if (redirectToReports) {
        return <Redirect to={`${routes.myReports}`} />;
    }

    const handleOnClickForgotPassword = () => {
        window.location.replace(`https://${GLOBAL.TENANT}.${CONSTANT.URLS.BASE_URL}/account/forgotpassword`);
    }

    const onClickChangeInputType = () => {
        if (inputType === 'text') {
            setInputType('password');
        } else {
            setInputType('text');
        }
    }

    const onClickTermOfServiceToggle = (e) => {
        e.preventDefault();
        setTermOfServiceModal(!termOfServiceModal);
    };

    const onClickPrivacyPolicyToggle = (e) => {
        e.preventDefault();
        setPrivacyPolicyModal(!privacyPolicyModal);
    };

    return (
        <div className="mmh-center-item-flex">

            {isDirectPaymentLoading
                ? (
                    <div className="position-center">
                        <i className="fa fa-spinner fa-spin font-size-4-rem"></i>
                    </div>
                )
                : (
                    <div className={`signup_signin_container mmh-flex-wrap ${(IsD2CEnabled && window.location.href.includes('package')) ? " mmh-align-content-start flex-grow-1 " : " mmh-align-content-center "}`}>
                        {props?.imgComponent ? props.imgComponent : <div></div>}
                        {/*<img src={leftIcon} className='left_icon'/>*/}
                        {/*<img src={doctorIcon} className='doctorimg'/>*/}
                        {/*<img src={topRoundIcon} className='halfround'/>*/}
                        {/*<img src={bottomRoundIcon} className='roundBottom'/>*/}

                        <div className={`signup_signin_form ${(IsD2CEnabled && window.location.href.includes('package')) ? "flex-grow-1 " : ""}`}>
                            <Formik
                                initialValues={initialValuesForLogin(directPaymentUserEmail)}
                                validationSchema={validationSchema()}
                                onSubmit={onSubmitLogin}
                            >
                                {({
                                    handleChange,
                                    handleSubmit,
                                    handleBlur,
                                    values,
                                    errors,
                                    touched,
                                    isSubmitting,
                                }) => (
                                    <div>
                                        <div className="color_logo_mmh">
                                            {props?.logoComponent ? props.logoComponent : <div></div>}
                                        </div>
                                        <div className="signup_signin_form_header">
                                            {/*<p> Registered {getUserIdentification()} </p>*/}
                                            {/*<p>Existing patients Sign in</p>*/}
                                            <p>{`Existing ${getUserIdentification()} Sign in`}</p>
                                        </div>

                                        {/*<PackageSmallDetails />*/}

                                        <form onSubmit={handleSubmit}>
                                            <div style={{ marginBottom: "3rem" }}>
                                                <label className="signup_signin_input-label">E-mail</label>
                                                <div className="signin_signin_input-container">
                                                    <span><i className="far fa-envelope icon-left"></i></span>
                                                    <input
                                                        className={`signup_signin_input-field
                                                            ${invalidFormElement(
                                                            "Email",
                                                            errors,
                                                            values,
                                                            touched
                                                        )}
                                                            `
                                                        }
                                                        type="email"
                                                        placeholder="Enter Email Address"
                                                        name="Email"
                                                        autoComplete="off"
                                                        onChange={(value) => {
                                                            props?.setEmailToLoadInitiallyAtSignIn
                                                                && props.setEmailToLoadInitiallyAtSignIn("")
                                                            handleChange(value)
                                                        }}
                                                        onBlur={handleBlur}
                                                        value={values.Email}
                                                    />
                                                </div>
                                                {errors.Email && touched.Email && (
                                                    <div className="error-message">{errors.Email}</div>
                                                )}

                                                {props?.emailToLoadInitially && (
                                                    <div className="">
                                                        <span className="text-success">
                                                            You are already registered. Please sign in.
                                                        </span>
                                                    </div>
                                                )}

                                            </div>
                                            <div style={{ marginBottom: "3rem" }}>
                                                <label className="signup_signin_input-label">Password</label>
                                                <div className="signin_signin_input-container">
                                                    <span><i className="fas fa-lock icon-left"></i></span>
                                                    <input className={`signup_signin_input-field ${invalidFormElement(
                                                        "Password",
                                                        errors,
                                                        values,
                                                        touched
                                                    )}`}
                                                        type={inputType}
                                                        placeholder="Enter Password"
                                                        name="Password"
                                                        autoComplete="off"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.Password}
                                                    />
                                                    <span>
                                                        {values.Password && inputType === 'password' && (
                                                            <i onClick={onClickChangeInputType}
                                                                className="fa fa-eye icon-right" />
                                                        )}
                                                        {values.Password && inputType === 'text' && (
                                                            <i onClick={onClickChangeInputType}
                                                                className="fa fa-eye-slash icon-right" />
                                                        )}
                                                    </span>
                                                </div>
                                                {errors.Password && touched.Password && (
                                                    <div className="error-message">
                                                        {errors.Password}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="displayFlex mmh-justify-end margin-bottom-3-rem">
                                                <div className="paddingTop10">
                                                    {/*metronics checkbox*/}
                                                    {/*<label*/}
                                                    {/*    className="kt-checkbox kt-checkbox--solid kt-checkbox--success signin-forgot-password">*/}
                                                    {/*    <input type="checkbox"/>Remember me?*/}
                                                    {/*    <span style={{ backgroundColor: "#0075B6" }}></span>*/}
                                                    {/*</label>*/}
                                                </div>
                                                <div className="cursor-pointer">
                                                    {/*<Link to={routes.forgot} className="signin-forgot-password">*/}
                                                    <div onClick={handleOnClickForgotPassword}
                                                        className="signin-forgot-password">
                                                        <Trans i18nKey="page.page.forgot-password" />
                                                    </div>
                                                    {/*</Link>*/}
                                                </div>
                                            </div>

                                            <div style={{ marginBottom: "2rem" }} className="signup_signin_submit_wrapper">
                                                {/*<button className="mb-3" onClick={(e) => {e.preventDefault(); login(); }}>Login SSO</button>*/}

                                                <button
                                                    type="submit"
                                                    className="signup_signin_submit"
                                                    disabled={isSubmitting}
                                                >
                                                    {isSubmitting ? (
                                                        <>
                                                            <i className="fa fa-spinner fa-spin" />&nbsp;&nbsp;
                                                            <Trans i18nKey="common.message.info.please-wait" />
                                                        </>
                                                    ) : (
                                                        // i18n.t("common.form.sign-in")
                                                        <>Submit</>
                                                    )}
                                                </button>
                                                {errorMessage && (
                                                    <div className=" text-center mt-2">
                                                        {/*style={{ fontSize: "1.25rem" }}>*/}
                                                        {/*<span className="kt-login__account-msg text-danger">*/}
                                                        <span className="error-message text-danger">
                                                            {errorMessage}
                                                        </span>
                                                    </div>
                                                )}
                                                {examneticsSuccessData && (
                                                    <div className="mt-3" style={{
                                                        backgroundColor: "#f0f8f1",
                                                        border: "1px solid #cce5d3",
                                                        borderLeft: "4px solid #28a745",
                                                        borderRadius: "0.25rem",
                                                        padding: "1rem",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "1rem",
                                                        textAlign: "left"
                                                    }}>
                                                        <div style={{
                                                            backgroundColor: "#d4edda",
                                                            borderRadius: "50%",
                                                            width: "50px",
                                                            height: "50px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            flexShrink: 0
                                                        }}>
                                                            <div style={{
                                                                backgroundColor: "#28a745",
                                                                borderRadius: "50%",
                                                                width: "32px",
                                                                height: "32px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center"
                                                            }}>
                                                                <i className="fa fa-check" style={{ color: "#ffffff", fontSize: "1rem" }}></i>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div style={{ color: "#155724", fontWeight: "600", fontSize: "1rem", marginBottom: "0.25rem" }}>
                                                                {examneticsSuccessData.Title}
                                                            </div>
                                                            <div style={{ color: "#155724", fontSize: "0.875rem" }}>
                                                                {examneticsSuccessData.Message}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </form>
                                        {!isAthleteEnabled && (
                                            <div className="signup_signin_registered">
                                                <div className="mmh-login-account cursor-pointer"
                                                    onClick={handleOnClickAreYouNewUser}>
                                                    <span className="">
                                                        {/*<Trans i18nKey="common.form.no-account-yet"/>*/}
                                                        <span>{`Are you a new ${getUserIdentification()}?`}</span>
                                                    </span>
                                                    &nbsp;&nbsp;
                                                    <a href={"!#"} rel="noopener noreferrer" className="signin-signup-link">
                                                        <Trans i18nKey="common.form.sign-up" />!
                                                    </a>
                                                </div>
                                            </div>
                                        )}

                                        {/*<div className="kt-login__account mmh-login-account cursor-pointer" onClick={onClickSignUp}>*/}
                                        {/*    <span className="kt-login__account-msg">*/}
                                        {/*        <Trans i18nKey="common.form.no-account-yet"/>*/}
                                        {/*    </span>*/}
                                        {/*    &nbsp;&nbsp;*/}
                                        {/*    <a href={"!#"} rel="noopener noreferrer" className="kt-login__account-link">*/}
                                        {/*        <Trans i18nKey="common.form.sign-up"/>!*/}
                                        {/*    </a>*/}
                                        {/*</div>*/}
                                        {!shouldHideTermsAndPrivacy && (
                                            <div className="signup_signin_terms_and_privacy_policy margin-top-2rem">
                                                <div className="mmh-login-terms">
                                                    <span className="">
                                                        <span
                                                            className="cursor-pointer text-decoration-underline-hover"
                                                            onClick={onClickTermOfServiceToggle}>
                                                            Terms & Services <span> </span>
                                                        </span>
                                                        /
                                                        <span
                                                            className="cursor-pointer text-decoration-underline-hover"
                                                            onClick={onClickPrivacyPolicyToggle}>
                                                            <span> </span>Privacy Policy
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                )}
                            </Formik>
                            {!shouldHideTermsAndPrivacy && termOfServiceModal && (
                                <DisplayUrlContent
                                    headerTitle={"Terms and Service"}
                                    open={termOfServiceModal}
                                    url={`https://${GLOBAL.TENANT}.injurycloud.com/account/termsofservice`}
                                    onToggleModal={onClickTermOfServiceToggle}>
                                </DisplayUrlContent>
                            )}
                            {!shouldHideTermsAndPrivacy && privacyPolicyModal && (
                                <DisplayUrlContent
                                    headerTitle={"Privacy Policy"}
                                    open={privacyPolicyModal}
                                    url={`https://${GLOBAL.TENANT}.injurycloud.com/account/privacypolicy`}
                                    onToggleModal={onClickPrivacyPolicyToggle}>
                                </DisplayUrlContent>
                            )}
                        </div>

                        {/*<AlertModal*/}
                        {/*    confirmBtnCssClass="btn btn-sm btn-success"*/}
                        {/*    showConfirm= {true}*/}
                        {/*    showCancel={false}*/}
                        {/*    show={showLogoutInfo}*/}
                        {/*    title=""*/}
                        {/*    type="info"*/}
                        {/*    onConfirm={() => {*/}
                        {/*        setShowLogoutInfo(false);*/}
                        {/*        GLOBAL.IS_LOGOUT_FOR_INACTIVE = false;*/}
                        {/*    }}*/}
                        {/*    confirmBtnText="Ok"*/}
                        {/*    closeOnClickOutside={false}>*/}
                        {/*    <div className='tele_sweetalert_message'>*/}
                        {/*        You are logged out for being inactive.*/}
                        {/*    </div>*/}
                        {/*</AlertModal>*/}

                        {showMobileAppSuggestion && (
                            <AlertModal
                                show={showMobileAppSuggestion}
                                confirmBtnCssClass="btn btn-sm btn-secondary"
                                // confirmBtnText="Cancel"
                                title='Device Compatibility Notice'
                                // onConfirm={onCancelMobileAppSuggestion}
                                closeOnClickOutside={false}
                                showConfirm={false}
                            >
                                <MobileAppSuggestionsModal />
                            </AlertModal>
                        )}
                    </div>
                )
            }
        </div>

    );
}

export default SignIn;
